import { Mail, MapPin, Phone, Trash2 } from "lucide-react";

export const STATUSES = ["new", "contacted", "approved", "archived"];
const INSURED = { yes: "Insured", "in-progress": "Insurance in progress", no: "Not insured" };

const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleString([], { dateStyle: "medium", timeStyle: "short" });
};

export const ApplicationCard = ({ app, onStatus, onDelete }) => (
  <article data-testid={`application-card-${app.id}`} className="rounded-[22px] border-2 border-black bg-white p-6 shadow-[5px_5px_0_#000]">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h3 className="font-display text-2xl font-black text-black">{app.full_name}</h3>
        {app.company && <p className="text-sm font-semibold text-neutral-700">{app.company}</p>}
        <p className="mt-1 text-xs text-neutral-600">{fmtDate(app.created_at)}</p>
      </div>
      <div className="flex items-center gap-2">
        <select value={app.status} onChange={(e) => onStatus(app.id, e.target.value)} data-testid={`application-status-${app.id}`} className="rounded-full border-2 border-black bg-[#E4E4E4] px-4 py-2 text-sm font-semibold capitalize text-black">
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <button onClick={() => onDelete(app.id)} data-testid={`application-delete-${app.id}`} aria-label="Delete application" className="grid h-10 w-10 place-items-center rounded-full border-2 border-black text-black transition-colors hover:bg-black hover:text-white">
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </div>
    <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm text-black">
      <a href={`tel:${app.phone}`} className="flex items-center gap-2 underline-offset-4 hover:underline"><Phone className="h-4 w-4" />{app.phone}</a>
      <a href={`mailto:${app.email}`} className="flex items-center gap-2 break-all underline-offset-4 hover:underline"><Mail className="h-4 w-4" />{app.email}</a>
      <span className="flex items-center gap-2"><MapPin className="h-4 w-4" />{app.location}</span>
    </div>
    <div className="mt-4 flex flex-wrap gap-2">
      {(app.services ?? []).map((s) => <span key={s} className="rounded-full bg-black px-3 py-1 text-xs font-semibold text-[#E4E4E4]">{s}</span>)}
    </div>
    <dl className="mt-4 grid gap-2 text-sm text-neutral-800 sm:grid-cols-3">
      <div><dt className="font-semibold text-black">Experience</dt><dd>{app.experience || "Not given"}</dd></div>
      <div><dt className="font-semibold text-black">Insurance</dt><dd>{INSURED[app.insured] ?? app.insured}</dd></div>
      <div><dt className="font-semibold text-black">Availability</dt><dd>{app.availability?.length ? app.availability.join(", ") : "Not given"}</dd></div>
    </dl>
    {app.message && <p className="mt-4 rounded-xl bg-[#F2F2F2] p-4 text-sm text-neutral-800">{app.message}</p>}
  </article>
);
